<div class="min-w-0 overflow-visible">
  <div
    [class]="itemListRowClass"
    [ngClass]="{
      'border-t border-surface-switch-200': item.full_index.length === 1,
      'item-list-row--nested': item.full_index.length % 2 === 0,
    }"
    [style.padding-left.rem]="item.full_index.length - 1"
    pDroppable
    [pDroppableDisabled]="
      !revisionItemService.draggingItem ||
      !canAcceptChildDrop(revisionItemService.draggingItem)
    "
    (drop)="onDropAsChild()"
    (click)="openDetails()"
  >
    <div
      class="col-span-1 flex min-w-0 items-center justify-start gap-1 py-3 pl-0 pr-1"
      (click)="$event.stopPropagation()"
    >
      <div
        class="inline-flex min-h-8 min-w-8 cursor-pointer items-center justify-center ml-3"
        (click)="onSelectionHitAreaClick($event)"
      >
        <p-checkbox
          [ngModel]="selectedPersistentIds.has(item.persistent_id)"
          (ngModelChange)="onSelectionChange($event)"
          [binary]="true"
          [attr.aria-label]="'Select ' + item.name"
          (click)="$event.stopPropagation()"
        />
      </div>
      <div
        pDraggable
        [pDraggableDisabled]="readOnly"
        (onDragStart)="revisionItemService.dragStart(item)"
        (onDragEnd)="revisionItemService.dragEnd()"
        class="inline-flex h-6 w-6 cursor-grab items-center justify-center rounded hover:bg-surface-switch-200"
      >
        <span
          class="material-symbols-outlined text-[14px] leading-none text-surface-switch-400"
          >drag_indicator</span
        >
      </div>
    </div>

    <div
      [class]="itemListBodyClass"
      [class.dragging-item]="
        revisionItemService.draggingItem &&
        revisionItemService.draggingItem.id === item.id
      "
    >
      <div class="col-span-3 flex min-w-0 items-center gap-2 py-3 font-bold">
        <div class="flex h-8 w-8 shrink-0 items-center justify-center">
          @if ((item.children ?? []).length) {
            <p-button
              text="true"
              severity="secondary"
              size="large"
              styleClass="!p-0 !w-8 !h-8 hover:!bg-surface-switch-200"
              [icon]="expanded ? 'pi pi-chevron-down' : 'pi pi-chevron-right'"
              (onClick)="toggleExpanded($event)"
            />
          }
        </div>
        <span
          class="min-w-0 break-words text-sm font-bold text-surface-switch-900 [overflow-wrap:anywhere]"
          >{{ item.full_index | quoteItemIndex }} {{ item.name }}</span
        >
        @if (item.cad_objects.length) {
          <span class="relative inline-flex items-center">
            <i
              class="pi pi-file-check cursor-pointer rounded p-1 text-sm text-primary hover:bg-surface-switch-200 transition-colors"
              [pTooltip]="
                item.cad_objects.length === 1
                  ? 'Linked to CAD object ' + item.cad_objects[0].name
                  : 'Linked to ' + item.cad_objects.length + ' CAD objects'
              "
              tooltipPosition="top"
              aria-label="Linked to CAD object(s)"
            ></i>
            <span
              class="absolute -right-1 -top-1 rounded-full bg-primary px-1 text-[10px] leading-none text-primary-contrast"
              >{{ item.cad_objects.length }}</span
            >
          </span>
        }
        @if (item.drawing_files.length) {
          <span class="relative inline-flex items-center">
            <i
              class="pi pi-file-pdf rounded p-1 text-sm text-primary hover:bg-surface-switch-200 transition-colors"
              [pTooltip]="
                'Linked to drawing PDF: ' + item.drawing_files[0].filename
              "
              tooltipPosition="top"
              aria-label="Linked to drawing PDF"
            ></i>
          </span>
        }
        @if (item.cad_inherited_from_name) {
          <i
            class="pi pi-arrow-up-left rounded p-1 text-sm text-primary hover:bg-surface-switch-200 transition-colors"
            [pTooltip]="'CAD inherited from ' + item.cad_inherited_from_name"
            tooltipPosition="top"
            aria-label="CAD inherited from parent"
          ></i>
        }
        @if (tradeStudyToolFeaturesEnabled && linkedCapexEquipmentCount) {
          <span class="relative inline-flex items-center">
            <i
              class="pi pi-wrench cursor-pointer rounded p-1 text-sm text-primary hover:bg-surface-switch-200 transition-colors"
              [pTooltip]="
                linkedCapexEquipmentCount === 1
                  ? 'Linked to CapEx equipment ' + linkedCapexEquipmentName
                  : 'Linked to ' +
                    linkedCapexEquipmentCount +
                    ' CapEx equipment items'
              "
              tooltipPosition="top"
              aria-label="Linked to CapEx equipment"
              (click)="$event.stopPropagation(); openDetails('capex')"
            ></i>
            <span
              class="absolute -top-1 -right-1 bg-primary text-primary-contrast text-[10px] rounded-full px-1 leading-none"
              >{{ linkedCapexEquipmentCount }}</span
            >
          </span>
        }
        @if (
          consumablesEnabled &&
          linkedConsumableCount &&
          !(item.children?.length ?? 0)
        ) {
          <span class="relative inline-flex items-center">
            <i
              class="pi pi-box cursor-pointer rounded p-1 text-sm text-primary hover:bg-surface-switch-200 transition-colors"
              [pTooltip]="
                linkedConsumableCount === 1
                  ? '1 consumable linked'
                  : linkedConsumableCount + ' consumables linked'
              "
              tooltipPosition="top"
              aria-label="Linked consumables"
              (click)="$event.stopPropagation(); openDetails('consumables')"
            ></i>
            <span
              class="absolute -top-1 -right-1 bg-primary text-white text-[10px] rounded-full px-1 leading-none"
              >{{ linkedConsumableCount }}</span
            >
          </span>
        }
        @if (hasDfmChecksInProgress) {
          <i
            class="pi pi-exclamation-circle cursor-pointer rounded p-1 text-sm text-amber-500 hover:bg-amber-100 transition-colors"
            pTooltip="DFM checks in progress, pricing may be incorrect"
            tooltipPosition="top"
            aria-label="DFM checks in progress, pricing may be incorrect"
            (click)="$event.stopPropagation(); openDetails('dfm')"
          ></i>
        }
        @if (hasFailedDfmChecks && !hasDfmChecksInProgress) {
          <i
            class="pi pi-exclamation-triangle cursor-pointer rounded p-1 text-sm text-red-500 hover:bg-red-100 transition-colors"
            pTooltip="Some DFM checks failed, pricing may be incorrect"
            tooltipPosition="top"
            aria-label="Some DFM checks failed, pricing may be incorrect"
            (click)="$event.stopPropagation(); openDetails('dfm')"
          ></i>
        }
        @if (hasCompletedDfmChecks) {
          <i
            class="pi pi-th-large cursor-pointer rounded p-1 text-sm text-secondary hover:bg-surface-switch-200 transition-colors"
            [pTooltip]="blockingUpTooltipContent"
            tooltipPosition="top"
            aria-label="DFM checks complete - Click to view details"
            (click)="$event.stopPropagation(); openDetails('dfm')"
          ></i>
          <ng-template #blockingUpTooltipContent>
            <div class="flex flex-col gap-1">
              @if (cadWarnings.length) {
                <div class="border-b border-surface-switch-200 pb-2">
                  Blocking up calculated and DFM checks complete.
                </div>
                <div class="font-bold">Possible CAD issues:</div>
                @for (warning of cadWarnings; track warning.cadObjectName) {
                  <div>
                    {{ warning.cadObjectName }}:
                    {{ warning.checkLabels.join(", ") }}
                  </div>
                }
              } @else {
                <div class="font-bold">
                  Blocking up calculated and DFM checks complete.
                </div>
              }
            </div>
          </ng-template>
        }
        @if (canOpenPricingDetails) {
          <i
            [class]="
              'pi cursor-pointer rounded p-1 text-sm ' +
              (isPriceOverridden
                ? 'pi-pencil text-amber-500'
                : 'pi-info-circle text-green-500') +
              ' hover:bg-surface-switch-200 transition-colors'
            "
            [pTooltip]="
              isPriceOverridden
                ? 'Price manually overridden. Click to view details.'
                : 'Price automatically calculated. Click to view details.'
            "
            tooltipPosition="top"
            aria-label="View pricing details"
            (click)="$event.stopPropagation(); openDetails('pricing')"
          ></i>
        }
      </div>

      <div
        class="relative col-span-1 flex items-center py-3 pl-4 text-sm italic text-surface-switch-900"
      >
        <div
          class="absolute inset-y-4 left-0 w-px bg-surface-switch-300"
          aria-hidden="true"
        ></div>
        <div class="min-w-0">
          @if (item.pricing_model_name) {
            <span>{{ item.pricing_model_name }}</span>
          } @else {
            <span class="text-muted-color italic">—</span>
          }
        </div>
      </div>
      <div
        class="col-span-1 flex items-center py-3 text-sm italic text-surface-switch-900"
      >
        <div class="min-w-0">
          @if (item.material_name) {
            <span>{{ item.material_name }}</span>
            @if (item.inherit_material) {
              <i
                class="pi pi-arrow-up-left ml-1 text-xs text-muted-color"
                pTooltip="Inherited from parent"
                tooltipPosition="top"
              ></i>
            }
          } @else {
            <span class="text-muted-color italic">None</span>
          }
        </div>
      </div>
      <div
        class="col-span-1 flex min-w-0 items-center py-3 text-sm italic text-surface-switch-900"
      >
        <div class="min-w-0">
          {{ item | quantity: "list" }}
          @if (item.batch_size) {
            <p-tag
              severity="secondary"
              class="ml-2"
              pTooltip="Charged by batch runs for the total quantity."
              tooltipPosition="top"
              >Batch priced</p-tag
            >
            <div class="text-xs text-muted-color">
              Batch: {{ item.batch_size }}
            </div>
            @if (item.batches_needed != null) {
              <div class="text-xs text-muted-color">
                {{ item.batches_needed }}
                {{ item.batches_needed === 1 ? "batch" : "batches" }} needed
              </div>
            }
          }
        </div>
      </div>
      <div
        class="relative col-span-1 flex items-center py-3 pl-4 text-sm tabular-nums text-surface-switch-900"
      >
        <div
          class="absolute inset-y-4 left-0 w-px bg-surface-switch-300"
          aria-hidden="true"
        ></div>
        <div class="min-w-0">
          {{ item.unit_cost | currency: currencyCode }}
          @if (item.batch_effective_unit_cost != null) {
            <div class="text-xs text-muted-color">
              {{ item.batch_effective_unit_cost | currency: currencyCode }} per
              part
            </div>
            <div class="text-xs text-muted-color italic">
              Contributes to parent unit cost
            </div>
          }
        </div>
      </div>
      @if (!tradeStudyToolFeaturesEnabled) {
        <div
          class="col-span-1 flex items-center py-3 text-sm tabular-nums text-surface-switch-900"
        >
          {{ item.unit_markup | currency: currencyCode }}
        </div>
      }
      <div
        class="col-span-1 flex min-w-0 items-center py-3 text-sm tabular-nums text-surface-switch-900"
      >
        <div class="min-w-0">
          {{ item.unit_price | currency: currencyCode }}
          @if (item.fixed_price && item.quantity_mode === QuantityMode.FIXED) {
            <div class="text-sm text-muted-color">
              +{{ item.fixed_price | currency: currencyCode }} fixed price
            </div>
          }
        </div>
      </div>
      @if (consumablesEnabled) {
        <div
          class="relative col-span-1 flex min-w-0 items-center py-3 pl-4 pr-2 text-sm italic tabular-nums text-surface-switch-900"
        >
          <div
            class="absolute inset-y-4 left-0 w-px bg-surface-switch-300"
            aria-hidden="true"
          ></div>
          <div class="min-w-0">
            @if (item.batches_needed != null) {
              {{
                item.batches_needed * +item.subtotal_consumables
                  | currency: currencyCode
              }}
            } @else {
              {{ item.subtotal_consumables | currency: currencyCode }}
            }
            @if (
              item.fixed_consumables &&
              item.quantity_mode === QuantityMode.SCALES
            ) {
              <div class="text-xs text-muted-color">
                +{{ item.fixed_consumables | currency: currencyCode }} fixed
              </div>
            }
          </div>
        </div>
      }
      <div
        class="relative col-span-1 flex min-w-0 items-center py-3 pl-4 text-sm italic tabular-nums text-surface-switch-900"
      >
        <div
          class="absolute inset-y-4 left-0 w-px bg-surface-switch-300"
          aria-hidden="true"
        ></div>
        <div class="min-w-0">
          @if (item.batches_needed != null) {
            {{
              item.batches_needed * +item.subtotal_price
                | currency: currencyCode
            }}
            <div class="text-xs text-muted-color">
              {{ item.batches_needed }} ×
              {{ item.subtotal_price | currency: currencyCode }} per batch run
            </div>
            <div class="text-xs text-muted-color italic">
              For total quantity, not per-part scaling
            </div>
          } @else {
            {{ item.subtotal_price | currency: currencyCode }}
          }
        </div>
      </div>
      @if (tradeStudyToolFeaturesEnabled) {
        <div
          class="col-span-1 flex min-w-0 items-center py-3 text-sm italic tabular-nums text-surface-switch-900"
        >
          @if (item.batches_needed != null) {
            {{
              item.batches_needed * +item.subtotal_capex
                | currency: currencyCode
            }}
          } @else {
            {{ item.subtotal_capex | currency: currencyCode }}
          }
        </div>
      }
      @if (!tradeStudyToolFeaturesEnabled) {
        <div
          class="col-span-1 flex items-center py-3 text-sm italic tabular-nums text-surface-switch-900"
        >
          @if (item.batches_needed != null) {
            {{
              item.batches_needed * +item.subtotal_tax | currency: currencyCode
            }}
          } @else if (item.subtotal_tax != null && item.subtotal_tax !== "") {
            {{ item.subtotal_tax | currency: currencyCode }}
          } @else {
            <span class="text-muted-color">—</span>
          }
        </div>
      }

      <div
        class="item-list-sticky-end relative col-span-2 flex items-center bg-inherit py-3 pl-4 -mr-2"
      >
        <div
          class="absolute inset-y-4 left-0 w-px bg-surface-switch-300"
          aria-hidden="true"
        ></div>
        <div class="flex-1 min-w-0 text-sm font-bold tabular-nums">
          @if (item.batches_needed != null) {
            {{
              item.batches_needed * +item.total_price | currency: currencyCode
            }}
          } @else {
            {{ item.total_price | currency: currencyCode }}
          }
          @if (item.quantity_mode === QuantityMode.FIXED) {
            <i
              class="pi pi-lock ml-1 text-xs text-surface-switch-500"
              pTooltip="Fixed price: this item's price does not change when changing the parent quantity."
              tooltipPosition="top"
              aria-label="Fixed quote item"
            ></i>
          }
          @if (item.fixed_price && item.quantity_mode === QuantityMode.SCALES) {
            <div class="text-sm text-muted-color">
              +{{ item.fixed_price | currency: currencyCode }} fixed price
            </div>
          }
        </div>
        <div
          class="flex min-w-[80px] shrink-0 items-center justify-end gap-1 pl-1"
          (click)="$event.stopPropagation()"
        >
          @if (visibleInPdf && (item.children ?? []).length) {
            <p-button
              text="true"
              severity="secondary"
              size="small"
              styleClass="!p-0 !min-w-8 !h-8 hover:!bg-surface-switch-200"
              [icon]="
                item.display_children_in_pdf ? 'pi pi-eye' : 'pi pi-eye-slash'
              "
              (onClick)="applyItemAction('update_pdf_visibility')"
            />
          }
          @if (!visibleInPdf) {
            <i
              animate.enter="enter-animation"
              animate.leave="leave-animation"
              class="ti ti-hidden-in-pdf text-surface-switch-500"
              style="font-size: 1.5rem"
              pTooltip="Hidden in PDF"
              tooltipPosition="top"
              aria-label="Hidden in PDF"
            ></i>
          }
          <p-button
            text="true"
            severity="secondary"
            size="small"
            styleClass="!p-0 !min-w-8 !h-8 hover:!bg-surface-switch-200"
            icon="pi pi-ellipsis-h"
            (onClick)="itemMenu.toggle($event)"
          />
          <p-popover #itemMenu>
            <ng-template #content>
              <div class="flex min-w-[160px] flex-col gap-0">
                <p-button
                  [label]="
                    'Add Subitem to ' +
                    (item.full_index | quoteItemIndex: { noTrailingDot: true })
                  "
                  icon="pi pi-plus"
                  [text]="true"
                  styleClass="w-full"
                  (onClick)="applyItemAction('create_item'); itemMenu.hide()"
                  [attr.aria-label]="
                    'Add Subitem to ' +
                    (item.full_index | quoteItemIndex: { noTrailingDot: true })
                  "
                />
                @if (item.cad_objects.length) {
                  <p-button
                    label="Download CAD"
                    icon="pi pi-download"
                    [text]="true"
                    styleClass="w-full"
                    (onClick)="downloadCad($event); itemMenu.hide()"
                    aria-label="Download CAD file"
                  />
                }
                <p-button
                  [label]="item.cad_objects.length ? 'Relink CAD' : 'Link CAD'"
                  icon="pi pi-file-check"
                  [text]="true"
                  styleClass="w-full"
                  (onClick)="openDetails('properties'); itemMenu.hide()"
                  [attr.aria-label]="
                    item.cad_objects.length
                      ? 'Relink CAD objects'
                      : 'Link CAD objects'
                  "
                />
                <p-button
                  label="Delete Item"
                  icon="pi pi-trash"
                  severity="danger"
                  [text]="true"
                  styleClass="w-full"
                  (onClick)="confirmDelete($event, itemMenu)"
                />
                <p-confirmpopup></p-confirmpopup>
              </div>
            </ng-template>
          </p-popover>
        </div>
      </div>
    </div>
  </div>

  @if (expanded && (item.children ?? []).length > 0) {
    <div
      class="children-collapse w-full"
      animate.enter="enter-children-animation"
      animate.leave="leave-children-animation"
      (click)="$event.stopPropagation()"
    >
      <div class="children-collapse-inner flex flex-col">
        <div
          class="w-full flex flex-col gap-0"
          [class.dragging-active]="revisionItemService.draggingItem"
        >
          @for (child of item.children ?? []; track child.persistent_id) {
            <div
              pDroppable
              (drop)="onDropBefore(child.persistent_id)"
              class="drop-line"
            ></div>
            <app-quote-revision-item
              [item]="child"
              [currencyCode]="currencyCode"
              [tradeStudyToolFeaturesEnabled]="tradeStudyToolFeaturesEnabled"
              [consumablesEnabled]="consumablesEnabled"
              [readOnly]="readOnly"
              [selectedPersistentIds]="selectedPersistentIds"
              [visibleInPdf]="item.display_children_in_pdf && visibleInPdf"
              (itemSelectionChange)="itemSelectionChange.emit($event)"
              (addItemRequested)="addItemRequested.emit($event)"
            />
            @if ($last) {
              <div pDroppable (drop)="onDropAtEnd()" class="drop-line"></div>
            }
          } @empty {
            <div pDroppable (drop)="onDropAsChild()" class="drop-line"></div>
          }
        </div>
        <div
          class="w-full flex mb-3 px-2 pt-3"
          [class.justify-start]="item.full_index.length === 1"
          [class.justify-center]="item.full_index.length >= 2"
        >
          <div
            [class.w-full]="item.full_index.length === 1"
            [class.max-w-xl]="item.full_index.length >= 2"
          >
            <p-button
              icon="pi pi-plus"
              severity="secondary"
              [label]="
                'Add Subitem to ' +
                (item.full_index | quoteItemIndex: { noTrailingDot: true })
              "
              [outlined]="false"
              (onClick)="
                $event.stopPropagation(); applyItemAction('create_item')
              "
            />
          </div>
        </div>
      </div>
    </div>
  }

  @if (detailsVisible) {
    <app-quote-revision-item-details
      [item]="item"
      [currencyCode]="currencyCode"
      [visible]="detailsVisible"
      [activePanel]="detailsPanel"
      [tradeStudyToolFeaturesEnabled]="tradeStudyToolFeaturesEnabled"
      [consumablesEnabled]="consumablesEnabled"
      [readOnly]="readOnly"
      (dialogClosed)="detailsVisible = false"
    />
  }
</div>
